const CONSTANTS = {
  FILTERS: {
    ALL: 'All',
    COMPLETE: 'Show Completed',
    UNCOMPLETE: 'Show Uncompleted'
  },
  STOREKEYS: {
    TODOLIST: 'todoListState',
    TODOLISTFILTER: 'todoListFilterState',
    TODOLISTSTATS: 'todoListStatsState',
    FILTEREDTODOLIST: 'filteredTodoListState'
  },
  NOTASKS: [
    'hot beverage',
    'cold beverage',
    'nap',
    'snack',
    'walk',  
    'stretch',
    'break',
  ]
}

export default CONSTANTS;